/**
 * The words for the X-card button.
 *
 * It was "✋ Move on", which said nothing about what it skips, and the hover talked about "this topic" — but there
 * is no separate topic: pressing it takes the most recent DM description you can see, cancels it if it is still
 * being written, and tells the DM never to describe anything like it again (Maz, 2026-10-21: "what is meant by the
 * topic? it needs to be clearer in what it would skip at that very moment"). So the button names that, and the
 * hover shows the very line.
 *
 * What it does is the server's: it cancels the beat being written, records that description as a standing
 * boundary on every later DM prompt, never stores or sends who pressed it, and rate-limits each player.
 */

export const X_CARD_LABEL = '✋ Skip the last DM description';

/** The preview line's length: enough to recognise the description by, short enough for a tooltip. */
const PREVIEW_CHARS = 110;

export const X_CARD_HELP =
  'The X-card. Stops this description and tells the DM never to describe anything like it again, for the rest of ' +
  'the campaign. Nobody is told who pressed it.';

/** What the hover says it will skip: the exact line, or that there is nothing yet. Pure, so it is tested directly. */
export function xCardPreview(lastDmLine: string | undefined): string {
  const text = lastDmLine?.replace(/\s+/g, ' ').trim();
  if (!text) return `${X_CARD_HELP} There is no DM description to skip yet.`;
  const shown = text.length > PREVIEW_CHARS ? `${text.slice(0, PREVIEW_CHARS).trimEnd()}…` : text;
  return `${X_CARD_HELP} Will skip: “${shown}”`;
}

export const X_CARD_BOUNDARY_HELP =
  'Pressing ✋ Skip the last DM description on the Table tab (the X-card) cancels that description and adds a ' +
  'boundary: something the DM is told never to describe again, for the rest of the campaign. Nobody is told who ' +
  'pressed it, and nobody here is shown what it was, so boundaries are only counted. ' +
  '“Lift the most recent” undoes the last one, in case it was pressed on the wrong moment — and whoever pressed ' +
  'it can undo it themselves for a few seconds.';
